import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./auth/login.component').then(m => m.LoginComponent) },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'comercios', loadComponent: () => import('./comercios/comercios.component').then(m => m.ComerciosComponent) },
      { path: 'comercios/:id', loadComponent: () => import('./comercios/comercio-detail/comercio-detail.component').then(m => m.ComercioDetailComponent) },
      { path: 'planes', loadComponent: () => import('./planes/planes.component').then(m => m.PlanesComponent) },
      { path: 'vendedores', loadComponent: () => import('./vendedores/vendedores.component').then(m => m.VendedoresComponent) },
      { path: 'conversaciones', loadComponent: () => import('./conversaciones/conversaciones.component').then(m => m.ConversacionesComponent) },
      { path: 'contactos', loadComponent: () => import('./contactos/contactos.component').then(m => m.ContactosComponent) },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
